/* ==========================================================================
   FUNNEL INSTRUMENTATION

   The size finder is the most important thing on this site and until now it
   was unmeasured. Without these events you can see that a visitor did not buy,
   but not whether they gave up choosing furniture, gave up choosing a size, or
   saw a price and left. Those are three different problems with three
   different fixes, and guessing between them wastes a month.

   Everything is pushed to dataLayer (GTM is already on the store), plus gtag
   and fbq when they exist, so it works with whatever is wired up without
   assuming any of them.

   Deliberately no personal data: no email, no name, no measurements that could
   identify a household. Sizes and prices only.
   ========================================================================== */
(function(){
  window.dataLayer = window.dataLayer || [];

  var sent = {};   // one-shot guard for the milestone events

  function track(name, data){
    var payload = data || {};
    payload.event = name;
    try { window.dataLayer.push(payload); } catch(e){}
    try { if(typeof gtag === 'function') gtag('event', name, data || {}); } catch(e){}
    try {
      if(typeof fbq === 'function'){
        // Only the two Meta recognises natively; the rest stay custom.
        if(name === 'bh_add_to_cart') fbq('track', 'AddToCart', data || {});
        else fbq('trackCustom', name, data || {});
      }
    } catch(e){}
  }
  function once(name, data){
    if(sent[name]) return;
    sent[name] = 1;
    track(name, data);
  }
  window.bhTrack = track;

  function ready(fn){
    if(document.readyState === 'complete') fn();
    else window.addEventListener('load', fn);
  }

  ready(function(){

    /* ---- the finder came into view. This is the denominator for every rate
            below, and without it a drop-off number means nothing. ---- */
    var finder = document.getElementById('finder');
    if(finder && 'IntersectionObserver' in window){
      new IntersectionObserver(function(entries, obs){
        entries.forEach(function(e){
          if(e.isIntersecting){
            once('bh_finder_view', {location: location.pathname});
            obs.disconnect();
          }
        });
      }, {threshold:0.3}).observe(finder);
    }

    /* ---- step 1: furniture chosen ---- */
    document.querySelectorAll('.type').forEach(function(b){
      b.addEventListener('click', function(){
        track('bh_finder_type', {furniture_type: b.dataset.type || 'unknown'});
      });
    });

    /* ---- step 2: the range buttons. Delegated, because the picker builds
            them after the furniture is chosen. ---- */
    document.addEventListener('click', function(e){
      var pick = e.target.closest && e.target.closest('.pick');
      if(pick){
        var row = pick.parentElement;
        var panel = row && row.parentElement;
        var isDepth = panel && Array.prototype.indexOf.call(panel.children, row) > 3;
        var label = (pick.querySelector('b') || {}).textContent || '';
        track(isDepth ? 'bh_finder_depth' : 'bh_finder_width', {
          choice: label.trim(),
          furniture_type: (typeof sel !== 'undefined' && sel.type) ? sel.type : 'unknown'
        });
        return;
      }

      /* ---- add to cart, from anywhere in the result ---- */
      var cart = e.target.closest && e.target.closest('a[href*="/cart/"]');
      if(cart){
        var m = cart.getAttribute('href').match(/\/cart\/(\d+)/);
        track('bh_add_to_cart', {
          variant_id: m ? m[1] : null,
          source: cart.closest('#out') ? 'size_finder' : 'other',
          furniture_type: (typeof sel !== 'undefined' && sel.type) ? sel.type : 'unknown'
        });
        return;
      }

      /* ---- the escape hatches. High counts here mean the guided path is
              failing somebody, which is worth knowing early. ---- */
      var t = e.target.closest && e.target.closest('a');
      if(!t) return;
      var txt = (t.textContent || '').toLowerCase();
      var href = t.getAttribute('href') || '';

      if(txt.indexOf('every size') > -1)          track('bh_show_all_sizes', {});
      else if(href.indexOf('measuring-guide') > -1) track('bh_measuring_guide', {});
      else if(href.indexOf('/pages/contact') > -1)  track('bh_contact_click', {});
      else if(txt.indexOf('type the numbers') > -1) track('bh_manual_entry', {});
      else if(href.indexOf('/pages/reviews') > -1)  track('bh_reviews_click', {});
    });

    /* ---- a result was produced. Watched rather than hooked, because the
            result is rendered by the matcher in several different places. ---- */
    var out = document.getElementById('out');
    if(out && 'MutationObserver' in window){
      new MutationObserver(function(){
        if(!out.querySelector('.result')) return;
        var price = out.querySelector('.price, .pprice');
        var kind  = out.querySelector('.optlist') ? 'options'
                  : (out.querySelector('.pairtotal') ? 'pair' : 'single');
        track('bh_finder_result', {
          result_type: kind,
          furniture_type: (typeof sel !== 'undefined' && sel.type) ? sel.type : 'unknown',
          price: price ? parseFloat((price.textContent || '').replace(/[^0-9.]/g,'')) : null
        });
      }).observe(out, {childList:true});
    }

    /* ---- content engagement. Cheap to collect, and it tells you which
            objections people actually have. ---- */
    document.querySelectorAll('.acc-t, .faq button, .faq summary').forEach(function(q){
      q.addEventListener('click', function(){
        track('bh_faq_open', {question: (q.textContent || '').trim().slice(0, 80)});
      });
    });

    document.querySelectorAll('.vid916 video').forEach(function(v){
      v.addEventListener('play',  function(){ once('bh_video_play', {}); });
      // A silent autoplay loop that nobody watches is worth knowing about too.
      v.addEventListener('timeupdate', function(){
        if(v.duration && v.currentTime / v.duration > 0.75) once('bh_video_75', {});
      });
    });

    var wall = document.querySelector('.rwall');
    if(wall){
      wall.addEventListener('scroll', function(){
        if(wall.scrollTop > 200) once('bh_reviews_scrolled', {});
      });
    }

    /* ---- how far down the page people actually get ---- */
    ['25','50','75'].forEach(function(){});
    var marks = [25, 50, 75];
    window.addEventListener('scroll', function(){
      var h = document.body.scrollHeight - window.innerHeight;
      if(h <= 0) return;
      var pct = (window.scrollY / h) * 100;
      marks.forEach(function(m){
        if(pct >= m) once('bh_scroll_' + m, {});
      });
    }, {passive:true});
  });
})();
